import { render } from "./WonderConfigurator.vue?vue&type=template&id=4723684b&scoped=true"
import script from "./WonderConfigurator.vue?vue&type=script&lang=js"
export * from "./WonderConfigurator.vue?vue&type=script&lang=js"

import "./WonderConfigurator.vue?vue&type=style&index=0&id=4723684b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4723684b"]])

export default __exports__